import { toast } from "react-toastify";
import Set from "../service/Set";
import queryClient from "../service/query";
import AttToken from "./attToken";

const callAssociateAll = async () => {
  const token = await AttToken();
  const setService = new Set();
  if (token) {
    toast.warn("Associando Formulários...");
    try {
      await setService.associateAll(token);
      queryClient.resetQueries({ queryKey: ["GET_CHECKLIST"], exact: true });
      toast.success("Formulários Associados!");
    } catch (err) {
      throw new Error("Falha ao associar formulários");
      // toast.warning("Falha!");
    }
  }
};

export default callAssociateAll;
